import {
  Menu,
  Dropdown,
  Icon,
  Button,
  Spin,
  Row,
  Col,
  Checkbox,
  Pagination
} from "antd";
const Menub = Menu.b;
import classnames from "classnames";
import isEqual from "lodash/isEqual";
import WeaNewScroll from "../../wea-new-scroll";
import WeaLocaleProvider from "../../wea-locale-provider";
import WeaZmage, { showImage } from "../../wea-zmage";
import { generateUUID } from "../../wea-zmage/utils";
import uniq from "lodash/uniq";

const getLabel = WeaLocaleProvider.getLabel;

class Main extends React.Component {
  static defaultProps = {
    defaultImg:
      (window.ecologyContentPath || "") +
      "/cloudstore/resource/pc/com/images/meeting_default.png"
  };
  constructor(props) {
    super(props);
    this.state = {
      hoverId: "",
      uid: `u${generateUUID()}`
    };
  }
  shouldComponentUpdate(nextProps, nextState) {
    return (
      !isEqual(this.props.browser, nextProps.browser) ||
      this.props.num !== nextProps.num ||
      !isEqual(this.props.ctrIds, nextProps.ctrIds)
    );
  }
  stopPropagation = e => {
    e && e.stopPropagation && e.stopPropagation();
    e && e.preventDefault && e.preventDefault();
  };
  checkboxOnChange(e, id) {
    this.stopPropagation(e);
    const { ctrIds, browser } = this.props;
    const datas = [];
    let ids = uniq([...ctrIds]);
    // if (e.target.checked) {
    //     ids.push(id);
    // } else {
    //     ids = ids.filter((i) => i != id);
    // }
    if (ids.indexOf(id) === -1) {
      ids.push(id);
    } else {
      ids = ids.filter(i => i != id);
    }
    browser.forEach(b => {
      if (ids.indexOf(b.id) > -1) datas.push(b);
    });
    this.props.thumbnailsOnCheck && this.props.thumbnailsOnCheck(ids, datas);
  }
  getImageUrl = b => {
    const { defaultImg } = this.props;
    let imgUrl = defaultImg;
    if (b.linkvaluecolumn) {
      imgUrl = `${b.imgurl}?${b.linkkey}=${b.linkvaluecolumn.split(",")[0]}`;
    }
    return imgUrl;
  };
  getImageSet = b => {
    const { defaultImg } = this.props;
    let imageSet = [];
    const { imgurl, linkkey, linkvaluecolumn, linktitlecolumn } = b;
    if (b && linkvaluecolumn) {
      const imgs = linkvaluecolumn.split(",");
      if (imgs && imgs.length) {
        imgs.map(i => {
          imageSet.push({
            src: `${imgurl}?${linkkey}=${i}`,
            alt: "",
            text: ""
          });
        });
      }
    }
    if (!imageSet.length) {
      imageSet.push({
        src: defaultImg,
        alt: "",
        text: ""
      });
    }
    return imageSet;
  };
  showImage = (e, b, index) => {
    e && e.stopPropagation && e.stopPropagation();
    showImage({
      id: `${this.state.uid}-${index}`,
      imageSet: this.getImageSet(b),
      page: 0
    });
  };
  render() {
    let { browser, num = 4, ctrIds = [], defaultImg, ecId } = this.props;
    const { uid } = this.state;
    let thumbnailsArr = [];
    const dom = (b, index) => {
      return (
        <Col
          ecId={`${ecId}_Col@ulwgqk@${index}`}
          class="wea-thumbnails-row"
          span={24 / num}
          style={{ minHeight: 220 }}
        >
          <div
            ecId={`${ecId}_div@s0rrne@${index}`}
            className="wea-thumbnails-box"
            onClick={e => this.checkboxOnChange(e, b.id)}
          >
            <div className="wea-thumbnails-check">
              <Checkbox
                ecId={`${ecId}_Checkbox@32ie69@${index}`}
                id={b.id}
                imgId={b.linkvaluecolumn.split(",")[0]}
                checked={ctrIds.indexOf(b.id) >= 0}
              />
            </div>
            <div
              ecId={`${ecId}_div@o34f9t@${index}`}
              className="wea-thumbnails-img-wrap"
              imgIds={b.linkvaluecolumn}
              // onClick={(...e)=>{console.log('img-wrap--onClick',e,b.linkvaluecolumn)}}
              onMouseEnter={() => this.setState({ hoverId: b.id })}
              onMouseLeave={() => this.setState({ hoverId: "" })}
            >
              {b.linkvaluecolumn ? (
                <img
                  ecId={`${ecId}_img@ozemdz@${index}`}
                  src={this.getImageUrl(b)}
                  id={`${uid}-${b.id}`}
                  alt=""
                  onClick={e => this.showImage(e, b, b.id)}
                />
              ) : (
                <div
                  ecId={`${ecId}_div@vqj6hi@${index}`}
                  onClick={e => this.stopPropagation(e)}
                >
                  <WeaZmage
                    ecId={`${ecId}_WeaZmage@03x3wq@${index}`}
                    src={defaultImg}
                  />
                </div>
              )}
              {b.roomdescspan && (
                <div
                  className={`wea-thumbnails-roomdesc`}
                  dangerouslySetInnerHTML={{ __html: b.roomdescspan }}
                />
              )}
            </div>
            {/* <div className='wea-thumbnails-supernatant'
                  style={{display:b.id == this.state.hoverId?'block':'none'}}>
                  {b.desccolumn}
                </div> */}
            <div
              className="wea-thumbnails-title wea-f14"
              title={b.linktitlecolumn}
            >
              {b.linktitlecolumn}
            </div>
            <div
              className="wea-thumbnails-subcolumn"
              title={b.subcolumn}
              style={{ color: "#ccc" }}
            >
              {b.subcolumn}
            </div>
            <div
              className={classnames({
                "wea-thumbnails-isused": true,
                isused: b.roomstatusspan == 1
              })}
            >
              {getLabel(510238, "已占用")}
            </div>
          </div>
        </Col>
      );
    };
    browser &&
      browser.forEach((b, index) => {
        thumbnailsArr.push(dom(b, index));
      });
    return (
      <div className="wea-thumbnails-table">
        <div
          className="wea-thumbnail-table-body"
          style={{ height: this.props.contentHeight || 450 }}
        >
          <WeaNewScroll ecId={`${ecId}_WeaNewScroll@c55c8u`} height={"100%"}>
            <Row ecId={`${ecId}_Row@wsndkh`}>{thumbnailsArr}</Row>
          </WeaNewScroll>
        </div>
      </div>
    );
  }
}
export default Main;



// WEBPACK FOOTER //
// ./ecology9/base/wea-browser-thumbnail/thumbnail.js